import { TenantTile } from "./tenant-tile";

import './../../pages/properties/property.css'; // TODO Should we share this or move it!?

export const TenantTiles = ({ tenants }) => {
    return (tenants && tenants.map(tenant => (
        <TenantTile tenant={tenant} key={`${tenant.id}`} />
    )));
};